import getLink from '../../config/urls'

function processData(data) {
  return data != null ? data.edges.map(edge => edge.node) : data
}

function isInternal(slug) {
  return /^\/(?!\/)/.test(slug)
}

/**
 * replaces
 */

// eslint-disable-next-line no-useless-escape
const URL_MATCHER = /(href\=")(.*?)("\>)/gm
// const URL_MATCHER = /(?<=\<\%\U\R\L\ )(.*?)(?=\ \%\>)/gm

export function replaceUrlsInHtmlString(str) {
  const matches = str.match(URL_MATCHER)
  if (matches && matches.length > 0) {
    matches.forEach(match => {
      const m = match.replace('href="', '').replace('">', '')
      // eslint-disable-next-line no-param-reassign
      str = str.replace(m, getLink(m))
    })
  }
  return str
}

function isChinese() {
  if (typeof window !== 'undefined') {
    const lang = window.location.hostname ? window.location.hostname.split('.')[0] : false;
    const languages = ['cn'];

    if (lang && languages.indexOf(lang) > -1) {
      return true;
    }
  }

  return false
}

function adobePageName(str) {
  if (str) {
    let newStr = str;


    if (newStr.substr(-1) === '/') {
      newStr = newStr.substr(0, newStr.length - 1);
    }

    if (newStr.substr(0, 1) === '/') {
      newStr = newStr.substr(1);
    }

    if (newStr === '') {
      return 'home';
    }

    return newStr.replace(/\//g, ':');
  }

  return 'home';
}

let adobeFirstLoad = false;
function adobePageLoad(pagePath, product) {
  let environment = 'dev'
  if (process.env.GATSBY_ACTIVE_ENV === 'production') {
    environment = 'prod'
  }

  if (typeof pageDataTracker === 'object') {
    // eslint-disable-next-line no-undef
    var pageData = {
      page: {
        name: adobePageName(pagePath),
        productName: 'ws',
        businessUnit: 'els:stmj:pbdv',
        type: product ? 'cp-ca' : 'ec-sc',
        environment,
      },
      visitor: {
        accessType: 'ae:anon::guest', // reg/anon depending on whether the user is signed in
      }
    };

    if (!adobeFirstLoad) {
      // eslint-disable-next-line no-undef
      pageDataTracker.trackPageLoad(pageData);
    } else {
      // eslint-disable-next-line no-undef
      pageDataTracker.trackEvent('newPage', {
        page: {
          name: adobePageName(pagePath),
          type: product ? 'cp-ca' : 'ec-sc',
          analyticsPagename: adobePageName(pagePath),
          sectionName: adobePageName(pagePath)          
        },
      });
    }

    adobeFirstLoad = true;
  }
}

export default {
  isInternal,
  processData,
  isChinese,
  adobePageName,
  adobePageLoad,
}
